import NavigableValidation from "./navigableValidation";
import UrlValidator from "../navigableValidators/urlValidator";
import FormDetailResource from "../../../formability/form_builder/models/formDetails/formDetailResource";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";

export default class FormDetailResourceValidation extends NavigableValidation<FormDetailResource> {
  validators = [
    new UrlValidator({validatorKey: 'url', section: ValidationModalSection.PublicProfile})
  ];

  getPath(propName: string, value?): string {
    switch (propName) {
      default:
        return `${this.getPageArea(propName).toLowerCase()}#${this.getAnchorHash(propName)}`
    }
  }

  getAnchorHash(propName: string, value?): string {
    return `resource_${propName.replace(/ /g, '')}_${this.model.client_id}`;
  }
}